import Helpers from '../Helpers'
class ResultsFacets {
    constructor(changeEvent) {
        const self = this
        this.facets = []
        this.tagFacetsOptions = []
        this.changeEvent = changeEvent
        Array.from(document.getElementsByClassName('results-aside__filter')).forEach(el => {
            this.facets.push(new ResultsFacet(el))
            new Helpers(el).eventListener(e=>{
                self.changeEvent(e, self)
            },'facet-change')
        })
    
    }

    getValues() {
        let values = {}
        let tags = []
        this.facets.forEach(f => {
            const value = f.getValue()
            if (value != null && value != '') {
                if (f.code in values) {
                    values[f.code] += `,${value}`
                  
                } else {
                    values[f.code] = value
                }
            }
        })
        return values
    }
    getNonDefaultValues() {
        let values = {}
        let tags = []
        this.facets.forEach(f => {
            const value = f.getValue()
            if (value != null && value != '') {
                if (f.code in values) {
                    values[f.code] += `,${value}`
                } else {
                    values[f.code] = value
                }
            }
        })
        return values
    }
    setValues(values) {
        this.facets.forEach(f => {

            if (values[f.code] != undefined) {
                f.setValue(values[f.code])
            } else {
                f.reset()
            }
        })
    }
}

class ResultsFacet {
    
    constructor(facet) {
        this.control = facet
        this.refine = null
        this.checkbox = null
        this.dropdown = null
        
        this.name = this.control.getAttribute('data-facet')
        this.code = this.control.getAttribute('data-qs-code')
        this.defaultValue = "" // this.control.getAttribute('data-defaultControlValue')
        this.getControls()

        this.toggleEvent()
    }

    getControls() {
        //find refine control
        const next = this.control.nextElementSibling
        if(next!= undefined && new Helpers(next).hasClass('results-aside__filter-refine')) {
            this.refine = new ResultsFacetRefine(next,this)
        }

        //find checkbox
        const input = this.control.getElementsByTagName('input')
        if(input.length == 1 && input[0].type === 'checkbox') {
            this.checkbox = input[0]
        }

        // find select
        const select = this.control.getElementsByTagName('select')
        if (select.length == 1) {
            this.dropdown = select[0]
        }
    }

    getValue() {
        if(this.checkbox != null && this.checkbox.checked == true) {
            if(this.refine != null) {
                return this.refine.getValue()
            } else {
                return this.checkbox.value
            }
        }

        if (this.dropdown != null) {
            return this.dropdown.value
        }

        if (this.checkbox == null) {
            if(this.refine != null) {
                return this.refine.getValue()
            }
        }
        return ''
    }

    setValue(value) {
        if (this.checkbox != null) {
            if (this.checkbox.value === "Y") {
                this.checkbox.checked = (value || '') !== ''
            } else {
                this.checkbox.checked = (value || '').split(',').indexOf(this.checkbox.value) >= 0
            }
            return this
        }

        if (this.dropdown != null) {
            this.dropdown.value = value || ''
            return this
        }

        if (this.refine != null) {
            this.refine.setValue(value)
            return this
        }
    }

    reset() {
        if (this.checkbox != null) {
            this.checkbox.checked = false
        } else {
            this.control.setAttribute('data-expanded', 'false')
        }
        if (this.refine != null) {
            this.refine.toggle(false)
        }
    }

    toggleEvent() {
        const self = this
        if (this.checkbox != null) {
            //checkbox toggle
            new Helpers(this.checkbox).eventListener((e) => {
                self.updateRefine()
                self.raiseEvent()
            }, 'change')
        } else if (this.dropdown != null) {
            // dropdown select
            new Helpers(this.dropdown).eventListener((e) => {
                self.updateRefine()
                self.raiseEvent()
            }, 'change')
        } else {
            new Helpers(this.control).eventListener((e) => {
                new Helpers(self.control).toggleAttribute('data-expanded')

                self.updateRefine()
            })
        }
    }

    updateRefine() {
        if(this.refine === null) return

        if(this.checkbox != null) {
            this.refine.toggle(this.checkbox.checked,true)
        } else {
            this.refine.toggle(this.control.getAttribute('data-expanded') === 'true',false)
        }
    }

    raiseEvent() {
        // TODO: add debounce logic
        this.control.dispatchEvent(new CustomEvent('facet-change'))
        // Track facet change in GTM
        window.dataLayerQueue.push({ 'event': 'searchInteraction', 'searchControl': this.name, 'searchControlValue': this.getValue() });
    }
}

class ResultsFacetRefine {
    constructor(refine, parent) {
        this.control = refine
        this.parent = parent

        // find all refine checkboxes
        this.checkboxes = Array.from(this.control.getElementsByTagName('input')).filter(input => input.type === 'checkbox')
        this.range = Array.from(this.control.getElementsByTagName('input')).filter(input => input.type === 'range')[0] || null
        

        this.changeEvent()
    }

    getValue() {
        let values = []
        if(this.checkboxes.length > 0 ) {
            this.checkboxes.filter(cbx => cbx.checked == true).forEach(cbx=> values.push(cbx.value))
        }
        if (this.range != null && this.range.value != '' && this.control.getAttribute('data-active') == 'true') {
            values.push(this.range.value)
        }
        return values.join(',')
    }

    visible(bool) {
        this.control.setAttribute('data-active', bool ? 'true' : 'false')
        return this
    }

    toggle(visible, defaultChecked) {
        this.visible(visible)

        this.checkboxes.forEach(checkbox => checkbox.checked = visible && defaultChecked)
        
        if (!visible && this.range != null) {
            // reset range to default value
            this.range.value = this.range.getAttribute('data-default')
        }
        return this
    }

    setValue(value) {
        const values = value.split(",")
        if (this.checkboxes.length > 0) {
            this.checkboxes.forEach(checkbox => checkbox.checked = values.indexOf(checkbox.value) >= 0)
            this.visible(this.checkboxes.filter(checkbox => checkbox.checked).length > 0)
        } else if (this.range != null) {
            this.range.value = value
            this.range.dispatchEvent(new CustomEvent('sync'))
            this.visible(value != '')
        }
    }

    changeEvent() {
        var self = this
        if(this.checkboxes.length > 0) {
            new Helpers(this.checkboxes).eventListener((e) => {
                
                //if no checkboxes are checked, clear the parent
                if(self.checkboxes.filter(cbx => cbx.checked == true).length == 0) {
                    self.parent.reset()
                }

                self.parent.raiseEvent()
            },'change')
        }

        if(this.range != null) {
            new Helpers(this.range).eventListener((e) => {
                self.parent.raiseEvent()
            },'change')
        }
    }
}


export default ResultsFacets